import c from 'classnames';
import { DesignButton, TextLink, Typography } from 'components';
import { useDispatch, useSelector } from 'react-redux';
import { getHasModalOpened, setModalOpened } from 'store/modal';

import styles from './ResultsAnnouncementBanner.module.css';

interface ResultsAnnouncementBannerProps {
  mainText: string;
  secondaryText: string;
  linkText: string;
  linkUrl: string;
}

const ResultsAnnouncementBanner = ({
  mainText,
  secondaryText,
  linkText,
  linkUrl,
}: ResultsAnnouncementBannerProps) => {
  const dispatch = useDispatch();

  // NOTE: This component isn't a modal. But this is the only way we have (so far) to handle a persistent dismiss.
  const modalIdentifier = {
    name: 'resultsAnnouncement',
    props: { mainText, secondaryText, linkText, linkUrl },
  };

  const isAnnouncementDismissed = useSelector(
    getHasModalOpened(modalIdentifier),
  );

  const dismiss = () => {
    dispatch(setModalOpened(modalIdentifier));
  };

  if (isAnnouncementDismissed) {
    return null;
  }

  return (
    <div className={c(styles.container, 'mt-3')}>
      <div className={styles.content}>
        <Typography
          variant='body-s'
          weight='medium'
          className={styles.mainText}
        >
          {mainText}
        </Typography>
        <Typography
          variant='body-s'
          className={c(styles.secondaryText, 'hide-on-mobile')}
        >
          {secondaryText}
        </Typography>
        <TextLink
          label={linkText}
          to={linkUrl}
          iconNameRight='chevronForward'
          target='_blank'
          rel='noopener noreferrer'
        />
      </div>
      <DesignButton
        variant='wrapper'
        label=''
        iconNameLeft='closeSm'
        onClick={dismiss}
      />
    </div>
  );
};

export default ResultsAnnouncementBanner;
